import React from "react";
import "./location.css";
import { useNavigate } from "react-router-dom";

function Location() {
  const navigate = useNavigate();

  const destinations = [
    {
      name: "Sigiriya Rock Fortress",
      img: "/sigiriya.jpg",
      path: "/locations/sigiriya",
      desc: "Ancient UNESCO World Heritage site with breathtaking sky-high views and royal history.",
      tag: "Best time: Early morning | Culture • History",
    },
    {
      name: "Kandy",
      img: "/kandy.webp",
      path: "/locations/kandy",
      desc: "The cultural capital, home to the sacred Temple of the Tooth and scenic lake views.",
      tag: "Best time: Evening walks | Culture • Heritage",
    },
    {
      name: "Ella",
      img: "/ella.jpg",
      path: "/locations/ella",
      desc: "Misty mountains, tea plantations, and one of the world's most scenic train journeys.",
      tag: "Best time: Morning hikes | Nature • Adventure",
    },
    {
      name: "Galle Fort",
      img: "/gallefort.jpg",
      path: "/locations/galle",
      desc: "A colonial fort city surrounded by ocean views, cafes, and cobblestone streets.",
      tag: "Best time: Sunset | History • Coastal",
    },
    {
      name: "Mirissa Beach",
      img: "/mirissa.jpg",
      path: "/locations/mirissa",
      desc: "Golden beaches, whale watching, and calm tropical ocean vibes.",
      tag: "Best time: Nov–Apr | Beach • Relax",
    },
    {
      name: "Nuwara Eliya",
      img: "/nuwara-eliya.jpg",
      path: "/locations/nuwara-eliya",
      desc: "Cool climate, tea estates, waterfalls, and colonial charm.",
      tag: "Best time: April season | Hills • Nature",
    },
  ];

  return (
    <div className="location-page">
      
      {/* HERO */}
<section
  className="location-hero"
  style={{
    backgroundImage: `url('/bannerceylonwayfinder.png')`
  }}
>
  <div className="overlay"></div>

  <div className="hero-content">
    <h1>
      Discover <span>Sri Lanka</span>
    </h1>

    <p>Luxury travel destinations with premium taxi service</p>

    <button
      className="hero-btn"
      onClick={() => navigate("/booking")}
    >
      Book a Ride
    </button>
  </div>
</section>

      {/* DESTINATIONS */}
      <section className="destinations">
        <div className="container">
          <div className="section-header">
            <h2>Top Destinations</h2>
            <p>Explore the most iconic places across the island</p>
          </div>

          <div className="grid">
            {destinations.map((item, index) => (
              <div
                key={index}
                className="card"
                onClick={() => navigate(item.path)}
              >
                <div className="img-wrapper">
                  <img src={item.img} alt={item.name} />
                </div>

                <div className="card-content">
                  <h3>{item.name}</h3>
                  <p>{item.desc}</p>
                  <small>{item.tag}</small>
                  <span className="link">Explore →</span>
                </div>
              </div>
            ))}
          </div>


        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <div className="cta-box">
          <h2>Ready to Travel?</h2>
          <p>Book your premium taxi service with Ceylon Wayfinder</p>

          <button onClick={() => navigate("/booking")}>
            Book Now
          </button>
        </div>
      </section>

    </div>
  );
}

export default Location;